// extracted by mini-css-extract-plugin
export default {"hideTooltip":"W9-z","fadeIn":"X9-z","delay":"Y9-z","recommendedSizeTooltip":"Z9-z"};